/*
 * @Author: aalizzwell
 * @Date: 2019-08-05 11:48:27
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2019-08-06 15:01:53
 */

import { Injectable, Optional } from '@angular/core';
import { EMPTY, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FrameContext, Repository, ViewModel } from '@farris/devkit';
import { FormMessageService } from './form-message.service';
import { LanguageService } from './languag.service';
import { BefRepositoryUtil, BefRepository } from '@farris/bef';
import { CommandService } from './command-service';

// tslint:disable: no-string-literal
/**
 * Gridä¸­é´ä»¶æå¡
 * @scope FrameComponent
 */
@Injectable()
export class GridMiddlewareService {
  private repository: Repository<any>;

  constructor(
    private frameContext: FrameContext,
    private msgService: FormMessageService,
    @Optional() private languageService: LanguageService,
    private viewModel: ViewModel,
    private commandService: CommandService
  ) {
    this.repository = this.frameContext.repository;
    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
  }
  /**
   * é¡µç åæ¢å
   */
  public onPageChanging() {
    if (this.isChanged) {
      return this.msgService.question(this.languageService['gridDataNotSave']).pipe(
        switchMap((result: boolean) => {
          if (!result) {
            return EMPTY;
          } else {
            return of(true);
          }
        })
      );
    } else {
      return of(true);
    }
  }
  /**
   * è¡¨æ ¼è¿æ»¤
   * @param commandName å½ä»¤åç§°
   * @param frameId frameId
   * @returns 
   */
  public filter(commandName: string, frameId: string) {
    const self: any = this;
    let filters = self.context && self.context.eventParam || [];
    if (typeof (filters) === 'string') {
      filters = JSON.parse(filters);
    }
    // æ¥è¯¢æ¶éç½®é¡µç ä¸ºç¬¬ä¸é¡µ
    this.viewModel.frameContext.repository.entityCollection.pageIndex = 1;
    this.viewModel.frameContext.repository.filterConditionManager.setConditions(this.viewModel.bindingPath, filters);
    return this.commandService.execute(commandName, frameId);
  }
  /**
   * æ¯å¦ææªä¿å­çåæ´
   */
  private get isChanged(): boolean {
    const befRepository = this.repository as BefRepository<any>;
    return BefRepositoryUtil.isExistUnsaveData(befRepository);
  }
}